import React, { useState } from "react";
import {
  LayoutSituation,
  StepCard,
  Divider,
  ResultsBloc,
  SearchBar,
} from "../../components";
import {
  DividerContainer,
  StepCardContainer,
  SearBarContainer,
  ResultsBlocContainer,
} from "./styled-components";
import SituationsBloc from "./components/situationsBloc";
import AlertSituationsBloc from "./components/alertSituationsBloc";
import OtherSituationBlock from "./components/otherExemplesBloc";
import { getIcons } from "../../helper/icons";
import { searchInAllData, searchInAlerteData } from "../../helper/search";
import { useNavigate } from "react-router-dom";

const Domain = ({ data, steps }: { data: Domain; steps: Step[] }) => {
  const navigate = useNavigate();
  const [results, setResults] = useState<SearchResult[] | null>();
  const [searchedValue, setSearchedValue] = useState("");

  const onSearchValue = (value: string) => setSearchedValue(value);

  const onDeleteSearch = () => {
    setResults(null);
    setSearchedValue("");
  };

  const handleSearchResults = () => {
    if (data.domain === "alerte") {
      setResults(searchInAlerteData(searchedValue) as any);
    } else {
      setResults(searchInAllData(searchedValue, data.domain));
    }
  };

  const renderSituations = () => {
    switch (data.domain) {
      case "alerte":
        return <AlertSituationsBloc data={data} />;

      case "autre":
        return <OtherSituationBlock data={data} />;

      default:
        return <SituationsBloc data={data} />;
    }
  };

  return (
    <LayoutSituation
      withUrgencyNumber={false}
      steps={steps}
      activeStep={2}
      onPrevious={() => navigate("/")}
    >
      <>
        <StepCardContainer>
          <StepCard
            color={data.color.light}
            step={`ÉTAPE 2 - ${data.step.title}`}
            title={data.step.subtitle}
            icon={getIcons(data.domain)}
          />
        </StepCardContainer>
        <SearBarContainer>
          <SearchBar
            domain={data.domain}
            searchedValue={searchedValue}
            onSearchValue={onSearchValue}
            handleSearchResults={handleSearchResults}
            onDeleteSearch={onDeleteSearch}
          />
        </SearBarContainer>
        {results ? (
          <ResultsBlocContainer>
            <ResultsBloc results={results} searchedValue={searchedValue} />
          </ResultsBlocContainer>
        ) : (
          <>
            <DividerContainer>
              <Divider />
            </DividerContainer>
            {renderSituations()}
          </>
        )}
      </>
    </LayoutSituation>
  );
};

export default Domain;
